import React from "react";

const Blogs = () => {
  return (
    <section className="min-h-screen">
      <h3 className="text-4xl text-secondary text-center font-BebasNeue">
        Coming Soon
      </h3>
    </section>
  );
};

export default Blogs;
